import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

type UpsertSquadProps = {
  squadId?: string;
  teamLeadPodTypeId?: string;
  name?: string;
  type?: string;
  communityChannelId?: string;
};

export const useUpsertSquad = () => {
  return useMutation(
    [`useUpsertSquad`],
    ({ squadId, teamLeadPodTypeId, name, type, communityChannelId }: UpsertSquadProps) =>
      apiFetch(null, `internal/expert-management/squads`, {
        method: 'POST',
        body: {
          squadId,
          teamLeadPodTypeId,
          name,
          type,
          communityChannelId,
        },
      }),
  );
};
